import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=3b50447a&scoped=true&"
import script from "./PostForm.vue?vue&type=script&lang=js&"
export * from "./PostForm.vue?vue&type=script&lang=js&"
import style0 from "./PostForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PostForm.vue?vue&type=style&index=1&id=3b50447a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b50447a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b50447a')) {
      api.createRecord('3b50447a', component.options)
    } else {
      api.reload('3b50447a', component.options)
    }
    module.hot.accept("./PostForm.vue?vue&type=template&id=3b50447a&scoped=true&", function () {
      api.rerender('3b50447a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/PostForm.vue"
export default component.exports